export { default as GDMTableBody } from './GDMTableBody';

export type { GDMTableBodyComponent, GDMTableBodyProps } from './GDMTableBody.type';
